/**
 * Extrait le prénom d'un displayName Graph.
 * Gère les deux conventions : "Prénom Nom" et "NOM Prénom" (format AVH fréquent).
 * Heuristique : si le premier mot est tout en majuscules (>=2 lettres), c'est le NOM → on prend le 2e mot.
 */
export function extractFirstName(displayName) {
    if (!displayName)
        return "";
    const parts = displayName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return "";
    if (parts.length === 1)
        return parts[0];
    const first = parts[0];
    const isAllCaps = first.length >= 2 && first === first.toUpperCase() && /[A-ZÀ-Ý]/.test(first);
    return isAllCaps ? parts[1] : parts[0];
}
